module.exports = __webpack_public_path__ + "img/main_product.b75c9523.jpg";